import styled from 'styled-components';

export const ResultBottomBar = styled.div.attrs({
  className: 'fixed bottom-0 left-0 right-0 z-50',
})``;
